import { render, staticRenderFns } from "./MbWorkSpace.vue?vue&type=template&id=fa62c93a&scoped=true"
import script from "./MbWorkSpace.vue?vue&type=script&lang=js"
export * from "./MbWorkSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa62c93a",
  null
  
)

export default component.exports